var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdmins = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 7A5 5 0 1 1 7 7a5 5 0 0 1 10 0Zm-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM13 19.956v2.006c-.328.025-.662.038-1 .038-4.97 0-9-2.79-9-5s4.03-4 9-4c1.391 0 2.709.14 3.884.39l-2.648 1.651c-.4-.027-.813-.041-1.236-.041-2.272 0-4.234.413-5.552 1-.661.293-1.073.592-1.292.822a.898.898 0 0 0-.15.194c.017.057.073.21.266.452.273.343.732.75 1.39 1.144C7.978 19.399 9.873 20 12 20c.34 0 .674-.015 1-.044Zm-8.006-2.91.003-.01a.046.046 0 0 1-.003.01Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 14.289a1 1 0 0 1 1 0l2.897 1.672a1 1 0 0 1 .5.866v3.346a1 1 0 0 1-.5.866L19 22.71a1 1 0 0 1-1 0l-2.897-1.672a1 1 0 0 1-.5-.866v-3.346a1 1 0 0 1 .5-.866L18 14.29Zm2 4.211a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
  fill: "currentColor"
})));
export default SvgAdmins;